/**
 * Same-origin URL for MapLibre's vector-tile worker.
 *
 * Vite's `?worker&url` pipeline has silently dropped the worker (or its
 * `maplibre-gl-shared.mjs` sibling) on Vite 8 production builds. The worker
 * is therefore copied into `public/maplibre/` next to that sibling and loaded
 * as a same-origin module — which also satisfies the SPA CSP `worker-src
 * 'self'` (no `blob:`).
 */
export function mapLibreWorkerUrl(origin: string, base = '/'): string {
  const root = base.endsWith('/') ? base : `${base}/`;
  return new URL(`${root}maplibre/maplibre-gl-worker.mjs`, origin).href;
}
